import { h, Component } from 'preact';
import { accessNested, sortObjectByOrder, joinClasses } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';
import Link from 'components/bolt/link/link';

import s from 'components/bolt/calendarRemind/calendarRemindButtons.sss';


export default class CalendarRemindButtons extends Component {
	constructor(props) {
		super(props);
		this.setCalData(props);
	}


	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.setCalData(this.props);
		}
	}

	setCalData(props) {
		const { remindMeDate, summary, description, location } = props;
		const startTime = formatDateTime(remindMeDate, 'yyyyMMdd');
		let endTime = remindMeDate.setDate(remindMeDate.getDate() + 1);
		endTime = formatDateTime(endTime, 'yyyyMMdd');
		const icsDescription = (description || '').split('\n').filter(a => a).join('\\n\\n');

		const icsCalendarContent = [
			'BEGIN:VCALENDAR',
			'VERSION:2.0',
			'PRODID:-//powster//NONSGML v1.0//EN',
			'BEGIN:VEVENT',
			// 'URL;VALUE=URI:' + siteUrl,
			'DTSTART;VALUE=DATE:' + (startTime || ''),
			'DTEND:' + (endTime || ''),
			'SUMMARY:' + summary,
			'DESCRIPTION:' + icsDescription,
			'LOCATION:' + location,
			'END:VEVENT',
			'END:VCALENDAR',
			''
		].join(typeof navigator !== 'undefined' && navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n');

		const icsHref = 'data:text/calendar;charset=utf8,' + encodeURIComponent(icsCalendarContent);

		this.calDetails = {
			googleCal: {
				name: 'Google Calendar',
				icon: 'googlecal.png',
				href: (
					[
						'https://www.google.com/calendar/render',
						'?action=TEMPLATE',
						'&text=' + encodeURIComponent(summary),
						'&location=' + encodeURIComponent(location),
						'&dates=' + (startTime || ''),
						'/' + (endTime || ''),
						'&details=' + encodeURIComponent([description].filter(e => e).join(' ')),
						'&sprop=&sprop=name:'
					].join('')),
				target: '_blank',
				order: 1
			},
			iCal: {
				name: 'Apple iCal',
				icon: 'ical.png',
				download: 'calendar.ics',
				href: icsHref,
				order: 2
			},
			outlook: {
				name: 'Microsoft Outlook',
				icon: 'outlook.png',
				download: 'calendar.ics',
				href: icsHref,
				order: 3
			},
			yahoo: {
				name: 'Yahoo',
				icon: 'yahoo.png',
				download: 'calendar.ics',
				href: icsHref,
				order: 4
			}
		};
	}

	getEnabledCals(calObj) {
		const calPriority = sortObjectByOrder(this.calDetails, (obj, cal) => cal).reverse();
		return Object.keys(calObj).filter(cal => calObj[cal] && calPriority.includes(cal)).sort((a, b) => calPriority.indexOf(b) - calPriority.indexOf(a));
	}

	renderCal(cal, i) {
		const sharedImageRoot = accessNested(Store.get(), 'appData.urls.roots.sharedImages');
		const { iconShade } = this.props;
		let calAriaLabel = accessNested(Store.get(), 'appData.copy.accessibilityCopy.$CALENDAR_NAME_ARIA');
		if (calAriaLabel) {
			calAriaLabel = calAriaLabel.replace('<calendar>', this.calDetails[cal].name);
		}
		const iconFolder = iconShade ? `cal-icons-${iconShade}` : `cal-icons-light`;
		let calColor;
		if (iconShade && iconShade === 'dark') {
			calColor = accessNested(Store.get(), 'appData.styling.variables.white', '#FFF');
		} else if (iconShade && iconShade === 'light') {
			calColor = accessNested(Store.get(), 'appData.styling.variables.black', '#000');
		}
		const homeEntCalNameOverride = accessNested(Store.get(), 'appData.styling.variables.homeEntCalNameColor');
		if (this.props.isHomeEnt && homeEntCalNameOverride) {
			calColor = homeEntCalNameOverride;
		}
		let calNameStyle = {
			color: calColor
		};

		return (
			<Link
				href={this.calDetails[cal].href}
				target={this.calDetails[cal].target}
				download={this.calDetails[cal].download}
				aria-label={calAriaLabel}
				title={this.calDetails[cal].name}
				key={cal}
				onClick={()=> {Store.emit('CALENDAR_CLICKED', {label: cal});}}
			>
				<div class={joinClasses(s.cal, i === 0 && s.firstCal)}>
					<div class={s.icon}>
						<img src={`${sharedImageRoot}/${iconFolder}/${this.calDetails[cal].icon}`}/>
					</div>
					<span class={s.calName} style={calNameStyle}>{this.calDetails[cal].name}</span>
				</div>
			</Link>
		);
	}


	render({ calObj, isShowtimes, isHomeEnt, chooseCalCopy }) {
		const enabledCalendars = this.getEnabledCals(calObj);
		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables', {});

		return (
			<div class={joinClasses(s.calendarOptions, isHomeEnt && s.homeEntCalOptions)}>
				<span class={joinClasses(s.chooseCal, isShowtimes && fontStyles.headerChooseCalendar, isHomeEnt && fontStyles.homeEntCalRemindChooseCalCopy)}>{chooseCalCopy}</span>
				{enabledCalendars.map((cal, i) => this.renderCal(cal, i))}
			</div>
		);
	}
}
